import { axiosCall } from "../../utils/axiosCall";

function initialState() {
  return {
    status: {
      indicators: "",
    },
    invitations: [],
  };
}

const state = initialState;

const getters = {
  getIndicators: (state) => state.invitations,
};

const actions = {
  INDICATORS_GET: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("setSurveyStatus", "adding");
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({ url: "Invitations/get/" + snapshotId })
        .then((resp) => {
          console.log(resp.data);
          commit("setSurveyStatus", "success");
          commit("setInvitations", resp.data.invitations);
          resolve(resp);
        })
        .catch((err) => {
          commit("setSurveyStatus", "error");
          reject(err);
        });
    });
  },
};

const mutations = {
  setSurveyStatus: (state, status) => {
    state.status = status;
  },
  indicatorReset: (state) => {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
